"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class LocalStorageHelps {
    saveDataLogin(response) {
        if (response?.refreshToken)
            localStorage.setItem('refreshToken', response.refreshToken);
        if (response?.accessToken)
            localStorage.setItem('accessToken', response.accessToken);
        if (response?.userId)
            localStorage.setItem('userId', response.userId);
        if (response?.expiresIn) {
            const expiryTime = new Date().getTime() + response.expiresIn * 1000;
            localStorage.setItem('expiresIn', expiryTime + '');
        }
        if (response?.access)
            localStorage.setItem('access', response.access);
    }
    deleteDataLogin() {
        localStorage.removeItem('refreshToken');
        localStorage.removeItem('accessToken');
        localStorage.removeItem('userId');
        localStorage.removeItem('expiresIn');
        localStorage.removeItem('access');
    }
}
exports.default = new LocalStorageHelps();
